import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { RoughRenderer } from './renderer';
var hasDocument = typeof document !== 'undefined';
export var RoughCanvasBase =
/*#__PURE__*/
function () {
  function RoughCanvasBase(canvas) {
    _classCallCheck(this, RoughCanvasBase);

    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');
  }

  _createClass(RoughCanvasBase, [{
    key: "draw",
    value: function draw(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.getDefaultOptions();
      var ctx = this.ctx;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var drawing = _step.value;

          switch (drawing.type) {
            case 'path':
              ctx.save();
              ctx.strokeStyle = o.stroke;
              ctx.lineWidth = o.strokeWidth;

              this._drawToContext(ctx, drawing);

              ctx.restore();
              break;

            case 'fillPath':
              ctx.save();
              ctx.fillStyle = o.fill || '';

              this._drawToContext(ctx, drawing);

              ctx.restore();
              break;

            case 'fillSketch':
              this.fillSketch(ctx, drawing, o);
              break;

            case 'path2Dfill':
              {
                this.ctx.save();
                this.ctx.fillStyle = o.fill || '';
                var p2d = new Path2D(drawing.path);
                this.ctx.fill(p2d);
                this.ctx.restore();
                break;
              }

            case 'path2Dpattern':
              {
                var doc = this.canvas.ownerDocument || hasDocument && document;

                if (doc) {
                  var size = drawing.size;
                  var hcanvas = doc.createElement('canvas');
                  var hcontext = hcanvas.getContext('2d');
                  var bbox = this.computeBBox(drawing.path);

                  if (bbox && (bbox.width || bbox.height)) {
                    hcanvas.width = this.canvas.width;
                    hcanvas.height = this.canvas.height;
                    hcontext.translate(bbox.x || 0, bbox.y || 0);
                  } else {
                    hcanvas.width = size[0];
                    hcanvas.height = size[1];
                  }

                  this.fillSketch(hcontext, drawing, o);
                  this.ctx.save();
                  this.ctx.fillStyle = this.ctx.createPattern(hcanvas, 'repeat');

                  var _p2d = new Path2D(drawing.path);

                  this.ctx.fill(_p2d);
                  this.ctx.restore();
                } else {
                  console.error('Cannot render path2Dpattern. No defs/document defined.');
                }

                break;
              }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "computeBBox",
    value: function computeBBox(d) {
      if (hasDocument) {
        try {
          var ns = 'http://www.w3.org/2000/svg';
          var svg = document.createElementNS(ns, 'svg');
          svg.setAttribute('width', '0');
          svg.setAttribute('height', '0');
          var pathNode = self.document.createElementNS(ns, 'path');
          pathNode.setAttribute('d', d);
          svg.appendChild(pathNode);
          document.body.appendChild(svg);
          var bbox = pathNode.getBBox();
          document.body.removeChild(svg);
          return bbox;
        } catch (err) {}
      }

      return null;
    }
  }, {
    key: "fillSketch",
    value: function fillSketch(ctx, drawing, o) {
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      ctx.save();
      ctx.strokeStyle = o.fill || '';
      ctx.lineWidth = fweight;

      this._drawToContext(ctx, drawing);

      ctx.restore();
    }
  }, {
    key: "_drawToContext",
    value: function _drawToContext(ctx, drawing) {
      ctx.beginPath();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = drawing.ops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;
          var data = item.data;

          switch (item.op) {
            case 'move':
              ctx.moveTo(data[0], data[1]);
              break;

            case 'bcurveTo':
              ctx.bezierCurveTo(data[0], data[1], data[2], data[3], data[4], data[5]);
              break;

            case 'qcurveTo':
              ctx.quadraticCurveTo(data[0], data[1], data[2], data[3]);
              break;

            case 'lineTo':
              ctx.lineTo(data[0], data[1]);
              break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (drawing.type === 'fillPath') {
        ctx.fill();
      } else {
        ctx.stroke();
      }
    }
  }], [{
    key: "createRenderer",
    value: function createRenderer() {
      return new RoughRenderer();
    }
  }]);

  return RoughCanvasBase;
}();